  import gdgPhoto from "../Assets/PhotoGDG.jpeg";

  export const profile = {
    name: "Matheus Pereira Gonsalves",
    titles: {
      en: ["Backend Engineer", "Backend Developer", "Web Developer"],
      pt: ["Engenheiro Backend", "Desenvolvedor Backend", "Desenvolvedor Web"],
    },
    bio: {
      en: [
        "Backend Developer focused on building scalable APIs and SaaS systems using Node.js and TypeScript.",
        "I develop RESTful services, implement authentication and authorization with JWT, and integrate relational databases such as PostgreSQL and MySQL.",
        "I have experience with production systems, including database modeling, Docker-based containerization, and application architecture decisions.",
        "I also build automations and proofs of concept with n8n, integrating external APIs and LLM-based solutions.",
      ],
      pt: [
        "Desenvolvedor Backend focado na construcao de APIs escalaveis e sistemas SaaS com Node.js e TypeScript.",
        "Desenvolvo servicos RESTful, implemento autenticacao e autorizacao com JWT e integro bancos relacionais como PostgreSQL e MySQL.",
        "Tenho experiencia com sistemas em producao, incluindo modelagem de banco de dados, containerizacao com Docker e decisoes de arquitetura.",
        "Tambem crio automacoes e provas de conceito com n8n, integrando APIs externas e solucoes baseadas em LLM.",
      ],
    },
    image: gdgPhoto,
    social: {
      email: "matheuspereiragonsalvespj@gmail.com",
      linkedin: "https://www.linkedin.com/in/matheuspereiragonsalves/",
      github: "https://github.com/Matheuspgonsalves",
    },
  };
